import "@/App.css";
import "@/i18n";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import WeeklyPlanning from "@/pages/WeeklyPlanning";
import Contracts from "@/pages/Contracts";
import ContractDetail from "@/pages/ContractDetail";
import Customers from "@/pages/Customers";
import Vehicles from "@/pages/Vehicles";
import Employees from "@/pages/Employees";
import Absences from "@/pages/Absences";
import ChecklistTemplates from "@/pages/ChecklistTemplates";
import Settings from "@/pages/Settings";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-zinc-400">
        <span className="font-display">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

const OwnerAdmin = ({ children }) => <ProtectedRoute roles={["owner", "admin"]}>{children}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <Toaster theme="dark" richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="planning" element={<OwnerAdmin><WeeklyPlanning /></OwnerAdmin>} />
              <Route path="contracts" element={<Contracts />} />
              <Route path="contracts/:id" element={<ContractDetail />} />
              <Route path="customers" element={<OwnerAdmin><Customers /></OwnerAdmin>} />
              <Route path="vehicles" element={<OwnerAdmin><Vehicles /></OwnerAdmin>} />
              <Route path="employees" element={<OwnerAdmin><Employees /></OwnerAdmin>} />
              <Route path="absences" element={<OwnerAdmin><Absences /></OwnerAdmin>} />
              <Route path="templates" element={<OwnerAdmin><ChecklistTemplates /></OwnerAdmin>} />
              <Route path="settings" element={<OwnerAdmin><Settings /></OwnerAdmin>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
